import { ReactElement, useState } from 'react'
import { Menu, MenuItem, IconButton, ListItemIcon } from '@mui/material'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import styled from 'styled-components'
import { Delete, Edit } from '@mui/icons-material'
import {
  VehicleWidgetDisplayState,
  vehicleWidgetStore,
} from '../../VehicleSearch/store/VehicleWidgetStore'
import { useNavigate } from 'react-router-dom'
import { StoreInstances } from '../../../../store/StoreInstancesContainer'
import { useSearchStore } from '../../../../store/search/SearchStore'
import { I18n } from 'common'
import { breakpoints } from '../../../../theme/breakpoints'
import { TrackingManager } from '../../../../config/analytics/tracking'

const ClearVehicleMenu = (): ReactElement => {
  const [anchorEl, setAnchorEl] = useState(null)
  const navigate = useNavigate()
  const searchStore = useSearchStore()

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleMenuClose = () => {
    setAnchorEl(null)
  }

  const handleDeleteVehicle = () => {
    if (
      window.location.pathname === '/partsCatalog' ||
      window.location.pathname === '/searchResults'
    )
      navigate('home')
    searchStore.deleteCurrentVehicle()
    vehicleWidgetStore.setIsDrawerOpened(false)
    vehicleWidgetStore.setDisplayState(VehicleWidgetDisplayState.select)
    StoreInstances.uiStore.displaySuccessNotification(
      'vehicleSuccessfullyDeleted'
    )
    TrackingManager.clearVehicle()
  }

  return (
    <MenuRow>
      <MoreIconButton
        aria-label="more"
        aria-controls="main-menu"
        aria-haspopup="true"
        onClick={handleMenuClick}
      >
        <MoreVertIcon />
      </MoreIconButton>
      <Menu
        id="main-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        <MenuItemRow
          onClick={() => {
            vehicleWidgetStore.setIsDrawerOpened(true)
            vehicleWidgetStore.setDisplayState(VehicleWidgetDisplayState.edit)
            handleMenuClose()
          }}
        >
          <ListItemIconRow>
            <Edit />
          </ListItemIconRow>
          <I18n name="changeVehicle"></I18n>
        </MenuItemRow>
        <MenuItemRow
          onClick={() => {
            handleMenuClose()
            handleDeleteVehicle()
          }}
        >
          <ListItemIconRow>
            <Delete />
          </ListItemIconRow>
          <I18n name="clearVehicle"></I18n>
        </MenuItemRow>
      </Menu>
    </MenuRow>
  )
}

const MenuRow = styled.div`
  display: none;
  @media (${breakpoints.tabletLarge}px <= width <= ${breakpoints.laptopMedium}px) {
    display: block;
  }
`

const MenuItemRow = styled(MenuItem)`
  width: 217px;
  height: 40px;
  font-weight: 700;
  font-size: 14px;
  padding: 8px 20px 8px 20px;
`

const ListItemIconRow = styled(ListItemIcon)`
  min-width: 34px !important;
`

const MoreIconButton = styled(IconButton)`
  padding: 8px 0px;
`
export default ClearVehicleMenu
